// Archivo para mostrar las grpaficas del dashboard
import React, { useMemo } from 'react'
import { Line } from 'react-chartjs-2'
import { Container, Typography, Box } from '@mui/material'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const MainChart = ({
  trend = [],
  loading = false,
  errorMessage = '',
  noDataMessage = '',
}) => {
  const chartData = useMemo(() => {
    const safeTrend = Array.isArray(trend) ? trend : []
    return {
      labels: safeTrend.map((item) => item.date),
      datasets: [
        {
          label: 'Actividades',
          backgroundColor: 'rgba(75,192,192,0.2)',
          borderColor: 'rgba(75,192,192,1)',
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          borderWidth: 2,
          data: safeTrend.map((item) => item.count),
          fill: true,
        },
      ],
    }
  }, [trend])
  const hasData = Array.isArray(trend) && trend.length > 0

  return (
    <Container>
      <Typography variant="h5" gutterBottom>
        Actividad por día
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: '800px',
          height: '400px',
          margin: '0 auto',
        }}
      >
        {loading ? (
          <Typography>Cargando gráfico...</Typography>
        ) : errorMessage ? (
          <Typography color="error">{errorMessage}</Typography>
        ) : (
          <>
            <Line
              data={chartData}
              options={{ maintainAspectRatio: false, responsive: true }}
            />
            {!hasData && (
              <Typography sx={{ marginTop: 2 }}>
                {noDataMessage}
              </Typography>
            )}
          </>
        )}
      </Box>
    </Container>
  )
}

export default MainChart
